import React, {useState} from 'react';
import {Button, Card, List, message, Tag, Typography} from 'antd';
import {useAppDispatch, useAppSelector} from '../hooks';
import {logout, patchAvatarIndex, setFirm, updateAvatarIndex} from '../features/user/userSlice';
import PasswordChangeModal from './PasswordChangeModal';
import {RootState} from "../store";
import PortraitSelect from "../components/PortraitSelect";
import {User} from "../interfaces/User"; // ⬅️ ajout

const {Title, Text} = Typography;

const Account: React.FC = () => {
    const {user} = useAppSelector((state: RootState) => state.user);
    const userFirms = localStorage.getItem('userFirms');
    const firms = userFirms ? JSON.parse(userFirms) : null;
    const savedFirm = localStorage.getItem('selectedFirm');
    const connectedFirm = savedFirm ? JSON.parse(savedFirm) : null;

    const dispatch = useAppDispatch();
    const [showPasswordModal, setShowPasswordModal] = useState(false);

    const handleLogout = () => {
        dispatch(logout());
        window.location.href = '/';
    };

    const handleFirmSwitch = (firmToSwitch: any) => {
        if (connectedFirm && connectedFirm.idt === firmToSwitch.idt) return;
        dispatch(setFirm(firmToSwitch));
        void message.success(`Firme changée vers : ${firmToSwitch.name}`);
    };

    // Avatar par défaut (adapte si tu as user.avatarIndex)
    const initialAvatarIndex = (user as User)?.avatarIndex ?? 0;

    const handleAvatarChange = (index: number) => {
        const previousIndex: number = user?.avatarIndex ?? 0; // <-- declare it here

        console.log('Updating avatar index:', index, 'previous was:', previousIndex);
        dispatch(updateAvatarIndex(index));
        dispatch(patchAvatarIndex(index)).unwrap()
            .then(() => {
                void message.success(`Avatar mis à jour (${index})`);
            })
            .catch((err) => {
                return message.error(`Échec de la mise à jour de l'avatar, veuillez réessayer (${err.message})`);
            });

    };

    return (
        <Card title="Mon compte" style={{maxWidth: 780, margin: '0 auto'}}>
            {/* Rangée: infos perso à gauche, avatar à droite */}
            <div style={{display: 'flex', gap: 24, alignItems: 'flex-start'}}>
                <div style={{flex: 1, minWidth: 0}}>
                    <Title level={4}>Informations personnelles</Title>
                    <p><Text strong>Nom : </Text>{user?.lastName}</p>
                    <p><Text strong>Prénom : </Text>{user?.firstName}</p>
                    <p><Text strong>Nom d'utilisateur : </Text>{user?.username}</p>
                </div>

                {/* Colonne droite : PortraitSelect (aperçu 200x200 + select popup) */}
                <div style={{width: 200, flex: '0 0 200px'}}>
                    <PortraitSelect
                        initialValue={initialAvatarIndex}
                        onSelect={handleAvatarChange}
                    />
                </div>
            </div>

            <Title level={5} style={{marginTop: 24}}>Firms associées</Title>
            <List
                bordered
                dataSource={firms || []}
                renderItem={(item: any) => {
                    const isCurrent = connectedFirm && item.idt === connectedFirm.idt;
                    return (
                        <List.Item
                            onDoubleClick={() => handleFirmSwitch(item)}
                            style={{backgroundColor: isCurrent ? 'var(--g-color-base-selection)' : undefined}}
                        >
                            <div style={{display: 'flex', flexDirection: 'column'}}>
                                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                                    <Text>{item.name}</Text>
                                    {isCurrent && <Tag color="green-inverse">Actif</Tag>}
                                </div>
                                {item.role && <Text type="secondary">Rôle : {item.role}</Text>}
                                {item.email && <Text type="secondary">Email : {item.email}</Text>}
                            </div>
                        </List.Item>
                    );
                }}
            />

            <div style={{marginTop: 24, display: 'flex', justifyContent: 'space-between'}}>
                <Button
                    style={{background: 'var(--g-color-private-blue-500)', color: 'white'}}
                    type="link"
                    onClick={() => setShowPasswordModal(true)}
                >
                    Changer mot de passe
                </Button>
                <Button
                    style={{background: 'var(--g-color-private-orange-450)', color: 'black'}}
                    type="primary"
                    danger
                    onClick={handleLogout}
                >
                    Se déconnecter
                </Button>
            </div>

            <PasswordChangeModal open={showPasswordModal} onClose={() => setShowPasswordModal(false)}/>
        </Card>
    );
};

export default Account;